import { render, staticRenderFns } from "./remarkButton.vue?vue&type=template&id=07056c88"
import script from "./remarkButton.vue?vue&type=script&lang=js"
export * from "./remarkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports